<template>
  <div class="file-uploader-popup">
    <el-row class="file-uploader-popup-inner">
      <el-col
        v-if="fileUploadData.displayName"
        :span="8"
        class="y-form-label"
      >{{fileUploadData.displayName}} </el-col>
      <el-col  v-if="isFontAvailable" :span="16" style="text-align:right">
        <span class="file-name-cnr">
            <el-button type="text" @click="deleteFile(fontBrandId)"><i class="el-icon-delete file-delete"></i> </el-button>
            <span :title="isFontAvailable" class="file-name">{{isFontAvailable}}</span>
        </span>
      </el-col>
      <el-col v-else :span="16" style="text-align:right">
        <el-link
          class="uploadFontBtn"
          size="mini"
          type="primary"
          outline
          @click="openPopup()"
          :autoid="fileUploadData.autoid"
        ><span v-if="updateUploadText"> {{fileUploadData.displayUpdateLinkName}} </span> <span v-else> {{fileUploadData.displayLinkName}}</span> </el-link>
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="popupProps.showPopup"
      :before-close="closePopupCallback"
      :class="popupProps.customClasses"
      :show-close="true"
    >
      <el-form
        ref="fontUploadForm"
        enctype="multipart/form-data"
        data-vv-scope="scopeFileUploadForm"
      >
        <el-row class="file-select-cnr">
          <el-col :span="24">
            <el-form-item>
              <el-upload
                autoid="customize-css-createbrand-fontupload-dropfile-button"
                class="upload-demo y-upload-popup"
                name="fontList"
                ref="uploadFile"
                drag
                action
                :limit="1"
                :auto-upload="false"
                :file-list="fileList"
                :on-change="changeFileHandler"
                :accept="popupProps.accept"
                :on-remove="removeFile"
              >
                <div class="el-upload__text">
                  Drag and drop or
                  <em>browse</em>
                </div>
                <!-- <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div> -->
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="file-error-cnr" v-if="showError">
          <el-col :span="24">
            <span class="errorField">
              <i class="el-icon-warning"></i>
              {{popupProps.errorMessage}}
            </span>
          </el-col>
        </el-row>
        <el-row class="file-error-cnr" v-if="showInfo">
          <el-col :span="24">
            <span class="infoField">
              <i class="el-icon-warning"></i>
              {{popupProps.infoMessage}}
            </span>
          </el-col>
        </el-row>
        <el-row class="file-upload-cnr">
          <el-col :span="24">
            <el-form-item>
              <el-button
                style="float: right"
                autoid="customize-css-createbrand-fontupload-uploadfont-button"
                class="uploadFontBtn"
                type="primary"
                @click="uploadFile"
              >{{popupProps.buttonName}}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <div style="display:none">{{closePopup}}</div>
  </div>
</template>
<script>
export default {
  created() {
    console.log('file upload', this.fileUploadData)
  },
  props: {
    fileUploadProps: Object,
    uploadHandler: Function,
    updateBtnText: Boolean,
    beforeUploadHandler: {
      type: Function,
      default: () => { console.log('default beforeUploadHandler func') }
    },
    removeHandler: {
      type: Function,
      default: () => { console.log('default removeHandler func') }
    },
    deleteFileName: {
      type: Function,
      default: () => { console.log('default deleteFileName func') }
    }
  },
  data() {
    return {
      updateUploadText: this.updateBtnText ? true : false,
      fileList: [],
      fileUploadData: this.fileUploadProps,
      popupProps: this.fileUploadProps.popupProps
    }
  },
  computed: {
    showError() {
      return !this.popupProps.isValid
    },
    showInfo() {
      return !this.popupProps.isInfo
    },
    closePopup() {
      if (!this.popupProps.isPopupOpen) {
        this.closePopupCallback()
      }
      return this.popupProps.isPopupOpen
    },
    isFontAvailable() {
      if ( this.$store.state.custAppStore.cobrandDraftData 
        && this.$store.state.custAppStore.cobrandDraftData.font 
        && this.$store.state.custAppStore.cobrandDraftData.font.default.length) {
          let formattedFileName = this.$store.state.custAppStore.cobrandDraftData.font.default[0].fileName
          return formattedFileName.substr(formattedFileName.indexOf('-')+1)
      } else {
        return ''
      }
    },
    fontBrandId() {
      return this.$store.state.custAppStore.cobrandDraftData.font.default[0].id
    }
  },
  methods: {
    deleteFile(fontId) {
      this.deleteFileName(
        'scopeFileUploadForm',
        fontId,
        this.fileUploadData
      )
    },
    removeFile() {
      this.removeHandler(
        'scopeFileUploadForm',
        this.$refs.uploadFile._data.uploadFiles,
        this.fileUploadData
      )
    },
    changeFileHandler(file, fileList) {
      this.beforeUploadHandler(
        'scopeFileUploadForm',
        this.$refs.uploadFile._data.uploadFiles,
        this.fileUploadData
      )
      this.popupProps.isValid = true
      console.log('changeeges')
    },
    openPopup() {
      this.popupProps.showPopup = false
      this.popupProps.showPopup = true
      this.popupProps.isPopupOpen = true
    },
    uploadFile() {
      this.uploadHandler(
        'scopeFileUploadForm',
        this.$refs.uploadFile._data.uploadFiles,
        this.fileUploadData
      )
      if (this.popupProps.isValid) {
        this.closePopupCallback()
      }
    },
    closePopupCallback() {
      this.popupProps.isPopupOpen = false
      this.popupProps.showPopup = false
      this.popupProps.isValid = true
      this.popupProps.isInfo = true
      if (this.$refs.uploadFile) this.$refs.uploadFile.clearFiles()
    }
  }
}
</script>
<style lang="scss">
.file-uploader-popup {
  .el-link--inner,
  .el-link--inner:hover {
    color: #267cb2;
    font-weight: bold;
  }
  .is-underline:hover::after {
    display: none;
  }
  .el-dialog {
    width: 638px !important;
    border-radius: 4px;
  }
  .el-dialog__header {
    // display: none;
    .el-dialog__headerbtn {
      min-width: auto !important;
      top: 8px;
      right: 10px;
    }
    .el-dialog__headerbtn .el-dialog__close {
        color: #747474;
        font-weight: bold;
    }
    .el-dialog__headerbtn:focus .el-dialog__close, 
    .el-dialog__headerbtn:hover .el-dialog__close {
      color: #747474;
    }
  }
  .el-dialog__body {
    padding: 24px;
    .ff-upload-btn-cnr {
      padding-bottom: 8px;
      border-bottom: 1px solid #dedede;
      button {
        padding: 9px;
      }
    }
    .file-select-cnr {
      .el-form-item {
      }
      .el-upload {
        display: block;
      }
      .el-upload-dragger {
        width: 590px;
        height: 184px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        text-align: center;
      }
      .el-upload-dragger .el-upload__text {
        color: #000000;
        font-size: 16px;
      }
      .el-upload-list {
        padding-left: 0;
      }
    }
    .file-upload-cnr {
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
  .file-name-cnr {
    max-width: 210px;
    .file-delete {
      color: #FF3A67;
      margin-right: 8px;
      display: inline-block;
      top: -6px;
      position: relative;
      // vertical-align: top;
    }
    .file-name {
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 185px;
      display: inline-block;
      white-space: nowrap;
    }
  }
  
}
</style>
